// beforeEach
// - Placeholder route guard
export const beforeEach = async (_to, _from, next) => {
  next()
}
